import i18n from './i18n/index'

export const debug = (...data) => console.debug('%c[Aeropost Search] %c%s', 'color:#0047a3;font-weight:bold', '', ...data)

export function resolveGateway() {
  const data = location.pathname.split('/').filter(Boolean)?.[0] || ''
  const [, gateway, locale] = data.match(/^([A-Z]{3})_([a-z]{2})$/) || []
  debug('Resolved gateway: ', gateway, locale)
  i18n.global.locale.value = locale
  
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  let utm_source, utm_medium, utm_campaign, ref_wk;

  if (params.toString().includes('utm_source') || params.toString().includes('utm_medium') || params.toString().includes('utm_campaign') || params.toString().includes('ref_wk')) {
      utm_source = params.get('utm_source');
      utm_medium = params.get('utm_medium');
      utm_campaign = params.get('utm_campaign');
      ref_wk = params.get('ref_wk');
  }

  return { gateway, locale, utm_source, utm_medium, utm_campaign, ref_wk };
}
